/* The blog, Wellness Radar (v4.24.0): sections/blog.liquid and sections/article.liquid. Everything a reader
   needs is in the server's HTML; this adds:
   - the contents list's current section, in blue (aria-current), as the reader scrolls;
   - Copy link and Print beside the byline (shown only when this runs), and every FAQ answer opened for print;
   - the email sign-up's two traps for bots (snippets/dmp-blog-signup.liquid): a filled hidden field is answered
     as if it worked, nothing is sent to Shopify, and the bot trap's recorder is told (assets/dm-bot-trap.js,
     'signup-field'); a send within 3 seconds of the page's load is held, and the person is asked to press again.
     Shopify's hCaptcha guards the form itself. */
(function () {
  'use strict';
  var root = document.querySelector('#content.dmb');
  if (!root) return;

  // ---------- the contents list's current section ----------
  var toc = root.querySelector('.dmb-toc');
  if (toc && 'IntersectionObserver' in window) {
    var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#dmb-s"]'));
    var heads = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
    var mark = function (id) {
      links.forEach(function (a) {
        if (a.getAttribute('href') === '#' + id) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    };
    var pick = function () {
      // the last heading above a line a third of the way down the window
      var line = window.innerHeight / 3;
      var current = heads[0];
      heads.forEach(function (h) { if (h.getBoundingClientRect().top <= line) current = h; });
      if (current) mark(current.id);
    };
    var io = new IntersectionObserver(pick, { rootMargin: '0px 0px -60% 0px' });
    heads.forEach(function (h) { io.observe(h); });
    window.addEventListener('scroll', function () { window.requestAnimationFrame(pick); }, { passive: true });
    pick();
  }
  // a link in the closed phone list closes it on the way
  root.querySelectorAll('.dmb-toc-m a').forEach(function (a) {
    a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.open = false; });
  });

  // ---------- Copy link, Print ----------
  var tools = root.querySelector('[data-dmb-tools]');
  if (tools) {
    tools.hidden = false;
    var said = tools.querySelector('[data-dmb-copied]');
    var copy = tools.querySelector('[data-dmb-copy]');
    if (copy) copy.addEventListener('click', function () {
      var url = window.location.origin + window.location.pathname;
      var done = function () {
        var label = copy.querySelector('span');
        label.textContent = 'Link copied';
        if (said) said.textContent = 'Link copied';
        window.setTimeout(function () { label.textContent = 'Copy link'; if (said) said.textContent = ''; }, 2500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
      else window.prompt('Copy this link:', url);
    });
    var print = tools.querySelector('[data-dmb-print]');
    if (print) print.addEventListener('click', function () { window.print(); });
  }
  var opened = [];
  window.addEventListener('beforeprint', function () {
    root.querySelectorAll('details.dmb-faq:not([open])').forEach(function (d) { d.open = true; opened.push(d); });
  });
  window.addEventListener('afterprint', function () { opened.forEach(function (d) { d.open = false; }); opened = []; });

  // ---------- topics, swapped in place (sections/blog.liquid) ----------
  // A chip is a real link to Shopify's own topic page (/blogs/help/tagged/<topic>), so it works without this and
  // opens in a new tab as any link does. Here a plain press fetches that page's rendering of this section only
  // (Shopify's Section Rendering API: <address>?section_id=<id>), puts its parts marked data-dmb-swap in place of
  // ours, keeps the chips where they were on the screen, marks the chip current, puts the address in the address
  // bar (Back and Forward swap the same way), moves focus to the list's heading and says what it shows. Anything that
  // goes wrong loads the page as a link would.
  var chips = root.querySelector('[data-dmb-chips]');
  var sectionId = root.getAttribute('data-section-id');
  if (chips && sectionId && window.fetch && window.DOMParser && window.history && history.pushState) {
    var said = root.querySelector('[data-dmb-said]');
    var cache = {};
    var asked = 0;
    var pathOf = function (href) { var u = new URL(href, window.location.href); return u.pathname.replace(/\/$/, ''); };
    // what is on screen: the path and the query (a page of the list, ?page=2), never section_id or the #part
    var keyOf = function (href) { var u = new URL(href, window.location.href); u.searchParams.delete('section_id'); return pathOf(u.href) + u.search; };
    var shown = keyOf(window.location.href);
    var markChip = function () {
      var path = pathOf(shown);
      chips.querySelectorAll('a.dmb-chip').forEach(function (a) {
        if (pathOf(a.href) === path) a.setAttribute('aria-current', 'page');
        else a.removeAttribute('aria-current');
      });
    };
    var swap = function (url, how) {
      var mine = ++asked;
      var latest = root.querySelector('[data-dmb-swap="latest"]');
      if (latest) latest.setAttribute('aria-busy', 'true');
      var key = new URL(url, window.location.href);
      key.hash = '';
      key.searchParams.set('section_id', sectionId);
      var got = cache[key.href] ? Promise.resolve(cache[key.href]) : fetch(key.href, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
      got.then(function (html) {
        if (mine !== asked) return; // a later press won
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('#content.dmb');
        var parts = root.querySelectorAll('[data-dmb-swap]');
        if (!next || !parts.length) throw new Error('no blog section in the answer');
        var fresh = [];
        parts.forEach(function (el) {
          var name = el.getAttribute('data-dmb-swap');
          var to = next.querySelector('[data-dmb-swap="' + name + '"]');
          if (!to) throw new Error('no ' + name + ' in the answer');
          fresh.push([el, document.importNode(to, true)]);
        });
        cache[key.href] = html;
        // the chips stay where they are on the screen, whatever changes above them
        var before = chips.getBoundingClientRect().top;
        fresh.forEach(function (pair) { pair[0].replaceWith(pair[1]); });
        var drift = chips.getBoundingClientRect().top - before;
        if (drift) window.scrollBy(0, drift);
        if (how === 'push') history.pushState({ dmbTopic: true }, '', url);
        shown = keyOf(url);
        markChip();
        // the layout's <title> holds entities of its own (&ndash;, &quot;): read them as the browser would
        var title = next.getAttribute('data-dmb-title');
        if (title) { var t = document.createElement('textarea'); t.innerHTML = title; document.title = t.value; }
        var latestNow = root.querySelector('[data-dmb-swap="latest"]');
        var count = latestNow && latestNow.getAttribute('data-dmb-count');
        var h1 = root.querySelector('[data-dmb-swap="title"] h1');
        var heading = root.querySelector('#dmb-latest-title');
        // the list's heading; on a topic page it is for screen readers only, so focus goes to the topic's name
        var focusTo = heading && heading.offsetWidth > 1 ? heading : (h1 && h1.hasAttribute('tabindex') ? h1 : heading);
        if (focusTo) focusTo.focus({ preventScroll: true });
        if (said) said.textContent = (h1 ? h1.textContent.trim() : '') + (count ? ': ' + count + (count === '1' ? ' article' : ' articles') : '');
      }).catch(function () {
        if (mine !== asked) return;
        // the page as a link would load it
        if (how === 'push') window.location.assign(url);
        else window.location.reload();
      });
    };
    history.replaceState(Object.assign({}, history.state, { dmbTopic: true }), '');
    chips.addEventListener('click', function (e) {
      var a = e.target.closest('a.dmb-chip');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.target && a.target !== '_self') return;
      var u = new URL(a.href, window.location.href);
      if (u.origin !== window.location.origin) return;
      e.preventDefault();
      if (keyOf(u.href) === shown) return; // already showing it
      swap(u.href, 'push');
    });
    window.addEventListener('popstate', function () {
      if (keyOf(window.location.href) === shown) return; // a jump within the page
      swap(window.location.href, 'pop');
    });
  }

  // ---------- the sign-up's traps for bots ----------
  var loaded = Date.now();
  root.querySelectorAll('form.dmb-letter__form').forEach(function (form) {
    var trap = form.querySelector('[data-dmb-trap]');
    var hold = form.querySelector('.dmb-letter__hold');
    var held = false;
    form.addEventListener('submit', function (e) {
      if (trap && trap.value) {
        // a person never sees this field: answer as if it worked, send nothing, tell the bot trap
        e.preventDefault(); e.stopImmediatePropagation(); // nor may Shopify's captcha script send it
        if (window.dmBotTrap) window.dmBotTrap.report('signup-field');
        var done = document.createElement('p');
        done.className = 'dmb-letter__done';
        done.setAttribute('role', 'status');
        done.textContent = 'Thank you. We\'ll email you when there\'s a new article.';
        form.replaceChildren(done);
        return;
      }
      if (Date.now() - loaded < 3000 && !held) {
        e.preventDefault(); e.stopImmediatePropagation();
        held = true;
        if (hold) hold.hidden = false;
        return;
      }
      if (hold) hold.hidden = true;
    });
  });
  // after a send, the page comes back with the thanks (or the error): bring it into view
  var answer = root.querySelector('.dmb-letter__done, .dmb-letter__error');
  if (answer && /customer_posted|#dmb-signup/.test(window.location.href)) {
    answer.scrollIntoView({ block: 'center' });
    if (answer.classList.contains('dmb-letter__done')) answer.focus({ preventScroll: true });
  }
})();
